export const calcMobileMenuBarConst = (array, param) => {
  return array.map(({ element, ...rest }) => {
    return {
      ...rest,
      path: rest.path + param,
    };
  });
};
